import './style.scss'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import { Link } from 'react-router-dom'
import { Alert, Button, Col, FormGroup, Input, Label, Row } from 'reactstrap'
import React, { useState } from 'react'

import operatorActions from 'redux/actions/user'
import { nxAuthTokenAct } from 'redux_new/actions'
import SidePopup from 'components/SidePopup'
import { apiAccount } from 'api'
import Nixi1Spinner from 'components/Nixi1Spinner'

/**
 * Login de operadores
 */
const Login = (props) => {
  const [state, setState] = useState({})
  const [isLoggingIn, setIsLoggingIn] = useState(false)
  const [errors, setErrors] = useState('')

  const operatorActs = bindActionCreators(operatorActions, props.dispatch)
  const onNxAuthToken = bindActionCreators(nxAuthTokenAct, props.dispatch)

  // Hidden popup
  const onHide = () => props.history.push('/')

  // Changed field values
  const onChange = ({ target: { name, value } }) => {
    setState({ ...state, [name]: value })
    setErrors('')
  }

  const onKeyPress = (e) => {
    if (e.key === 'Enter') onSubmit(e)
  }

  const onSubmit = (e) => {
    e.preventDefault()

    if (!state.email && !state.password) return

    setIsLoggingIn(true)

    apiAccount
      .login(state)
      .then(({ data, status }) => {
        if (status !== 200) throw data.error

        onNxAuthToken.add(data.token)
        return data.token
      })
      .then((authToken) => {
        operatorActs.getOperator(authToken)

        setIsLoggingIn(false)
      })
      .catch((error) => {
        setErrors(error.response.data.error || error.message)
        setIsLoggingIn(false)

        if (error.response.data.url_to) window.location.assign(error.response.data.url_to)
      })
  }

  const { email, password } = state

  return (
    <SidePopup onHide={onHide}>
      <Row className='login-form'>
        <Col xs={12}>
          <div className='section-title'>{I18n.t('dashboard_hello-again')}</div>
          <div className='section-subtitle'>{I18n.t('dashboard_login')}</div>
        </Col>

        <Col xs={12} className='mt-3'>
          <FormGroup>
            <Label for='email'>{I18n.t('dashboard_email')}</Label>
            <Input type='email' name='email' id='email' value={email || ''} onChange={onChange} onKeyPress={onKeyPress} />
          </FormGroup>
          <FormGroup>
            <Label for='password'>{I18n.t('dashboard_password')}</Label>
            <Input type='password' name='password' id='password' value={password || ''} onChange={onChange} onKeyPress={onKeyPress} />
          </FormGroup>
        </Col>
        {errors && (
          <Col xs={12}>
            <Alert color='danger'>{I18n.t(`dashboard_errors_${errors}`)}</Alert>
          </Col>
        )}
        <Col xs={6} className='align-self-center mt-3'>
          <Link to='/change-password' className='reset-password'>
            {I18n.t('dashboard_restore-password')}
          </Link>
        </Col>
        <Col xs={6} className='mt-3'>
          <Button color='primary' onClick={onSubmit} disabled={isLoggingIn} className='w-100'>
            {isLoggingIn ? <Nixi1Spinner height='1rem' width='1rem'/> : I18n.t('button_login')}
          </Button>
        </Col>
      </Row>
    </SidePopup>
  )
}

export default connect()(Login)
